import * as yup from 'yup';

export interface IDontHaveFiles {
	files?: File[];
	additionalInformation?: string;
	instructionsToStaff: string;
}

export const dontHaveFilesInitialValues: IDontHaveFiles = {
	files: [],
	additionalInformation: '',
	instructionsToStaff: null,
};

export const dontHaveFilesSchema = yup.object().shape({
	instructionsToStaff: yup.string().required('required'),
	additionalInformation: yup.string().when('instructionsToStaff', {
		is: 'openUp',
		then: yup.string(),
		otherwise: yup.string().required('required'),
	}),
	email: yup.string().email('email-format').required('required'),
});
